<template>
  <div class="loading-container">
    <div class="loading-content">
      <div class="loading-card">
        <p v-if="isSuccess">{{ $t('Aktivitasi berhasil') }}</p>
        <p v-else>{{ $t('Sedang submit') }}</p>
        <el-progress
          class="w-100"
          :stroke-width="5"
          :percentage="100"
          status="success"
          v-if="isSuccess"
        ></el-progress>
        <el-progress :stroke-width="5" :percentage="percentage" v-else></el-progress>
        <p v-if="!isSuccess">{{ $t('Sedang mengaktifkan akun terkait, silahkan ditunggu') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    status: String,
    speed: Number
  },
  data() {
    return {
      timer: null,
      percentage: 0
    }
  },
  computed: {
    isSuccess() {
      return this.percentage === 100 || this.status === 'success'
    }
  },
  methods: {
    counter() {
      this.timer = setTimeout(() => {
        if (this.percentage < 99) {
          this.percentage += 1
          this.counter()
        }
      }, (this.speed || 1000) * Math.random().toFixed(2))
    }
  },
  mounted() {
    this.counter()
    /* setTimeout(() => { */
    /*   clearTimeout(this.timer) */
    /*   this.percentage = 100 */
    /*   this.$emit('update:status', 'success') */
    /* }, 5 * 1000) */
  }
}
</script>

<style lang="scss" scoped>
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.58);
}
.loading-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  max-width: 28rem;
  margin: 1.5rem auto;
}
.loading-card {
  background-color: #ffffff;
  padding: 1.5rem;
  border-radius: 4px;
  min-height: 10rem;
  p {
    font-size: 0.875rem;
    color: #666;
  }
}
</style>
